import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import CircularProgress from "@material-ui/core/CircularProgress";

import { AppState } from "../../../../store/";
import { getDocumentsTypes } from "../../../document-type/store/actions";
import {
  sendDocument,
  getDocumentById,
  editDocumentFields,
} from "../../store/actions";

import { InputErrors } from "../../../../models/interfaces";
import {
  DocumentToPost,
  Document_DocumentTypesToGet,
  Document_DocumentTypesToGet_documentTypeFields,
  FileUpload,
  DocumentEditResponse,
  DocumentStatusType,
  DocumentFileActionType,
} from "../../models/interfaces";

import config from "../../../../config";

import {
  formatDateCurrentString,
  formatDateString,
  formatDate,
  validStringDate,
} from "../../../../utils";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { ptBR } from "date-fns/locale";

import theme from "../../../../styles/theme";
import {
  Container,
  IButton,
  InputText,
  InputSelect,
  ButtonSend,
  styleError,
} from "../../../../styles/styles";
import { useHistory, useParams } from "react-router-dom";
const INITIAL_DocumentTypeSelected: Document_DocumentTypesToGet = {
  id: 0,
  name: "",
  active: true,
  requiredDescription: false,
  documentTypeFields: [],
};

const INITIAL_Document: DocumentToPost = {
  id: 0,
  expirationDate: "",
  description: "",
  status: DocumentStatusType.Pendente,
  active: true,
  message: "",
};

const DocumentCreate: React.FC = () => {
  const authType: string = useSelector( (state: AppState) => state.Authorization.authType );

  const [SendDocument, setSendDocument] = useState<boolean>(false);
  const [ DocumentTypeSelected, setDocumentTypeSelected ] = useState<Document_DocumentTypesToGet>(INITIAL_DocumentTypeSelected);
  const [InputErrors, setInputErrors] = useState<InputErrors[]>([]);
  const [Document, setDocument] = useState<DocumentToPost>(INITIAL_Document);
  const [file, setFile] = useState<FileUpload>({});
  const [ selectedDateExpiration, setSelectedDateExpiration ] = useState<Date | null>();
  const [ selectedDateExpirationString, setSelectedDateExpirationString ] = useState<string>("");

  const listDocumentTypes: Document_DocumentTypesToGet[] = useSelector((state: AppState) => state.DocumentType.listDocumentTypes);
  const isLoadingDocumentType = useSelector((state: AppState) => state.DocumentType.isLoading);
  const isLoadingDocument = useSelector((state: AppState) => state.Document.isLoading);

  const { id, providerId } = useParams<{id: string, providerId: string}>();
  const history = useHistory();
  const minDate = new Date();

  useEffect(() => {

    if (Document.expirationDate === "" || Document.expirationDate === null) {
      return setSelectedDateExpiration(null);
    }

    if (validStringDate(Document.expirationDate)) {
      return setSelectedDateExpiration(
        formatDate(Document.expirationDate.replace(/[/]/g, "-"))
      );
    }

  }, [Document]);

  useEffect(() => {

    if ( selectedDateExpiration !== null || selectedDateExpiration !== undefined ) {
      setSelectedDateExpirationString(
        formatDateString(selectedDateExpiration)
        );
    }

  }, [selectedDateExpiration]);

  useEffect(() => {
    getDocumentsTypes();

    if (id) {
      getDocumentById(parseInt(id))
        .then((res: DocumentEditResponse) => {
          setDocumentTypeSelected(res.providerDocumentFields);
          setDocument(res.Document);
          if (Boolean(res.Document.fileName)) {
            let { fileName } = res.Document;
            const posBar = fileName ? fileName?.lastIndexOf("/") : 0;
            fileName = fileName?.substring(posBar + 1, fileName?.length);
            setFile({ fileName: fileName });
            setSendDocument(true);
          }
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            title: "Erro",
            text: `Ocorreu algum erro ao carregar os dados`,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
          history.push(`/document${providerId ? "/" + providerId : ""}/list`);
        });
    }
  }, [id, history, providerId]);

  const handleDateChange = (date: Date | null) => {
    setSelectedDateExpiration(date);
  };

  const handleSelectDocumentType = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    var verifyValue = listDocumentTypes.find(
      (object) => object.id === parseInt(event.target.value)
    );
    if (verifyValue) {
      removeErrorsInput("documentType");
      let documentSelected: Document_DocumentTypesToGet = verifyValue;
      documentSelected.documentTypeFields.map(
        (
          element: Document_DocumentTypesToGet_documentTypeFields,
          index: number
        ) => {
          return (documentSelected.documentTypeFields[index].answer = {
            documentTypeFieldId: element.id,
            value: "",
          });
        }
      );
      setDocumentTypeSelected(documentSelected);
    }
  };

  const handleChangeValueField = (
    event: React.ChangeEvent<HTMLSelectElement>,
    documentTypeFieldId: any
  ) => {
    let indexDocumentTypeField = DocumentTypeSelected.documentTypeFields.findIndex(
      (object: Document_DocumentTypesToGet_documentTypeFields) =>
        object.id === documentTypeFieldId
    );

    if (
      typeof indexDocumentTypeField !== "undefined" &&
      indexDocumentTypeField !== -1
    ) {
      DocumentTypeSelected.documentTypeFields[indexDocumentTypeField].answer = {
        ...DocumentTypeSelected.documentTypeFields[indexDocumentTypeField]
          .answer,
        documentTypeFieldId,
        value: event.target.value,
      };
      setDocumentTypeSelected({ ...DocumentTypeSelected });
    }
  };

  const handleSubmit = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    if (verifyInputError()) {
      return;
    }

    const answers = DocumentTypeSelected.documentTypeFields.map((element) => {
      return element.answer;
    });

    if (
      selectedDateExpirationString === "" ||
      selectedDateExpirationString.indexOf("NaN") === 1
    ) {
      return Swal.fire({
        title: "Data de Expiração Inválida!",
        html: `Informe uma data de expiração válida.`,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: theme.palette.primary.main,
        confirmButtonText: "OK",
      });
    }

    const params: DocumentToPost = {
      ...Document,
      providerId: providerId
        ? providerId === "all"
          ? Document.providerId
          : parseInt(providerId)
        : undefined,
      documentTypeId: DocumentTypeSelected.id,
      title: DocumentTypeSelected.name,
      file: file?.fileByte,
      fileName: file?.fileName,
      expirationDate: selectedDateExpirationString,
      providerDocumentFields: answers,
      status: DocumentStatusType.Pendente,
      message: "",
    };

    if (
      authType !== config.userTypeAdmin &&
      Document?.status === DocumentStatusType.Vencido
    ) {
      if (
        params?.expirationDate !==
        (formatDateCurrentString(
          Document?.expirationDate.replace(/\//g, "-")
        ))
      ) {
        if (params?.fileAction !== DocumentFileActionType.Change) {
          return Swal.fire({
            title: "Ops!",
            html: `Para alterar a data de expiração do documento é necessário enviar um novo documento.`,
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: theme.palette.primary.main,
            confirmButtonText: "OK",
          });
        }
      } else {
        return Swal.fire({
          title: "Ops!",
          html: `Para alterar a data de expiração do documento é necessário enviar um novo documento.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: theme.palette.primary.main,
          confirmButtonText: "OK",
        });
      }
    }

    let textLoading = "Enviando...";
    let textTitleSuccess = "Documento enviado";
    let textSuccess = "foi enviado com sucesso !";

    if (!id) {
      if (params.file === "" || params.file === undefined) {
        return Swal.fire({
          title: "Ops!",
          html: `É necessário enviar um documento para realizar o cadastro.`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: theme.palette.primary.main,
          confirmButtonText: "OK",
        });
      }
    }

    if (id) {
      textLoading = "Editando...";
      textTitleSuccess = "Tipo de Documento Editado";
      textSuccess = "foi editado com sucesso !";
      params.id = parseInt(id);
    }

    Swal.fire({
      title: "Aguarde...",
      text: textLoading,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: async () => {
        Swal.showLoading();

        const res = !id
          ? await sendDocument(params)
          : await editDocumentFields(params);

        if (res) {
          Swal.fire({
            title: textTitleSuccess,
            html: `O Documento <b>${params.title}</b> ${textSuccess}`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: theme.palette.primary.main,
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Erro",
            text: `Ocorreu algum erro ao executar a ação!`,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
          });
        }

        setInputErrors([]);
        setDocument(INITIAL_Document);
        setDocumentTypeSelected(INITIAL_DocumentTypeSelected);
        setSendDocument(false);
        setFile({});

        history.push(`/document${providerId ? "/" + providerId : ""}/list`);
      },
    });
  };

  const validateForm = () => {
    if (DocumentTypeSelected.id === 0) {
      if (
        InputErrors.findIndex((object) => object.input === "documentType") ===
        -1
      ) {
        setInputErrors([...InputErrors, { input: "documentType" }]);
      }
    }

    if (!Boolean(file.fileName) && SendDocument) {
      if (
        InputErrors.findIndex((object) => object.input === "uploadFile") === -1
      ) {
        setInputErrors([...InputErrors, { input: "uploadFile" }]);
      }
    } else if (
      typeof file.fileByte === "undefined" &&
      Document.fileAction === DocumentFileActionType.Change
    ) {
      if (
        InputErrors.findIndex((object) => object.input === "uploadFile") === -1
      ) {
        setInputErrors([...InputErrors, { input: "uploadFile" }]);
      }
    } else {
      removeErrorsInput("uploadFile");
    }
  };

  const removeErrorsInput = (input: string) => {
    const index = InputErrors.findIndex((object) => object.input === input);
    if (index !== -1) {
      InputErrors.splice(index, 1);
    }
  };

  const verifyInputError = (input?: string): Boolean => {
    const index = Boolean(input)
      ? InputErrors.findIndex((object) => object.input === input)
      : InputErrors.length;

    if ((Boolean(input) && index !== -1) || (!Boolean(input) && index > 0)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUploadFile = async (event: any) => {
    if (event.target.files[0]) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;
      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = function () {
        let baseUrl = reader.result?.toString();
        baseUrl = baseUrl?.split(';base64,')[1];
        setFile({ fileByte: baseUrl, fileName });
      };

      reader.onerror = function (error) {
        console.log("Error: ", error);
      };

      removeErrorsInput("uploadFile");
    }
  };

  const ButtonUploadFile = () => {
    const ButtonRes = (
      <Button
        variant="contained"
        component="label"
        style={{
          marginLeft: 10,
          color: "#ffffff",
          background: "#26b2d1",
          ...(verifyInputError("uploadFile") ? styleError : null),
        }}
      >
        Selecione o arquivo

        <input
          type="file"
          id="upload-button"
          accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          style={{ display: "none" }}
          onChange={handleUploadFile}
        />
      </Button>
    );

    if (Document?.fileAction === DocumentFileActionType.Change || Document.id === 0) {
      return ButtonRes;
    }

  };

  return (
    <React.Fragment>
      <Container background="#E2E4E6">
        {((!id && isLoadingDocumentType) || (id && isLoadingDocument)) && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress size={25} />
          </div>
        )}
        {((!id && !isLoadingDocumentType) || (id && !isLoadingDocument)) && (
          <ValidatorForm
            onSubmit={(e: any) => handleSubmit(e)}
            onError={() => validateForm()}
          >
            <div style={{ flexDirection: "row", display: "flex" }}>
              <div style={{ flex: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                      <InputSelect
                        label="Tipo de Documento"
                        inputProps={{ "aria-label": "Without label" }}
                        variant="outlined"
                        value={DocumentTypeSelected.id}
                        errorstyle={
                          verifyInputError("documentType") ? styleError : null
                        }
                        onChange={(e: any) => handleSelectDocumentType(e)}
                        errorMessages={["Campo obrigatório"]}
                        disabled={!!Document?.documentTypeId}
                      >
                        <MenuItem value={0} disabled>
                          SELECIONE
                        </MenuItem>
                        {listDocumentTypes?.map((element) => (
                          <MenuItem value={element.id} key={element.id}>
                            {element.name}
                          </MenuItem>
                        ))}
                      </InputSelect>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {id && Document.fileName && (
                      <div style={{ marginLeft: 10, marginBottom: 10 }}>
                        <FormControlLabel
                          control={
                            <Radio
                              color="default"
                              checked={
                                Document.fileAction ===
                                DocumentFileActionType.Keep ||
                                Document.fileAction == null
                              }
                              onChange={() =>
                                setDocument({
                                  ...Document,
                                  fileAction: DocumentFileActionType.Keep,
                                })
                              }
                            />
                          }
                          label="Manter"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              color="primary"
                              checked={
                                Document.fileAction ===
                                DocumentFileActionType.Change
                              }
                              onChange={() =>
                                setDocument({
                                  ...Document,
                                  fileAction: DocumentFileActionType.Change,
                                })
                              }
                            />
                          }
                          label="Alterar"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              color="secondary"
                              checked={
                                Document.fileAction ===
                                DocumentFileActionType.Remove
                              }
                              onChange={() =>
                                setDocument({
                                  ...Document,
                                  fileAction: DocumentFileActionType.Remove,
                                })
                              }
                            />
                          }
                          label="Remover"
                        />
                      </div>
                    )}
                    {ButtonUploadFile()}

                    {Boolean(file.fileName) && (
                      <>
                      <br/>
                        <span
                          style={{
                            marginLeft: 20,
                            fontWeight: "bold",
                            fontSize: 14,
                          }}>
                          Nome do Documento:
                        </span>
                        <span>
                          {file.fileName}
                        </span>
                      </>
                    )}

                    {Document.id !== 0 && !Boolean(file.fileName) && (
                      <span>Documento não enviado.</span>
                    )}

                  </Grid>
                  <Grid item xs={12}>
                    <InputText
                      label="Descrição do Documento"
                      type="text"
                      value={Document.description}
                      fullWidth
                      variant="outlined"
                      multiline 
                      validators={
                          !DocumentTypeSelected.requiredDescription &&
                          Document.description === "" ? ["required"] : []}
                      rows={8}
                      rowsMax={8}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setDocument({
                          ...Document,
                          description: e.target.value,
                        })
                      }
                      errorMessages={["Campo obrigatório"]}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Data de Válidade"
                        invalidDateMessage="Data em formato inválido."
                        format="dd/MM/yyyy"
                        value={selectedDateExpiration}
                        onChange={handleDateChange}
                        minDate={minDate}
                        minDateMessage={`A data deve ser maior que a data de hoje.`}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                </Grid>
              </div>
              <div style={{ flex: 1 }}>
                <Grid container spacing={2}>
                  {DocumentTypeSelected.documentTypeFields.map((element) => (
                    <React.Fragment key={element.id}>
                      <Grid item xs={12}>
                        <InputText
                          label={element.description}
                          type={element.fieldType}
                          value={element.answer.value}
                          fullWidth
                          variant="outlined"
                          onChange={(e: any) =>
                            handleChangeValueField(e, element.id)
                          }
                          validators={element.allowsNull ? ["required"] : []}
                          errorMessages={["Campo obrigatório"]}
                        />
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>
              </div>
            </div>
            <ButtonSend>
              <IButton
                width={130}
                background="#26B2D1"
                type="button"
                style={{ marginRight: 10 }}
                onClick={() => {
                  history.goBack();
                }}
              >
                VOLTAR
              </IButton>
              <IButton
                width={130}
                background="#52D126"
                type="submit"
                style={{ marginRight: 10 }}
                onClick={validateForm}
              >
                ENVIAR
              </IButton>
            </ButtonSend>
          </ValidatorForm>
        )}
      </Container>
    </React.Fragment>
  );
};

export default DocumentCreate;
